import { render, staticRenderFns } from "./TrabajoEdit.vue?vue&type=template&id=dabec6de&"
import script from "./TrabajoEdit.vue?vue&type=script&lang=js&"
export * from "./TrabajoEdit.vue?vue&type=script&lang=js&"
import style0 from "./TrabajoEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports